import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

productListLineStyles.addToCartButton = {
    css: css`
        width: 100%;
        border-radius: 24px;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                    padding: 0px 9px;
                `,
                css`
                    padding: 0px 9px;
                `,
                css`
                    @media (min-width: 992px) and (max-width: 1024px) {
                        + div {
                            > div[class^="TooltipWrapper"]{
                                position: relative;
                                top: 7px;
                                left: 5px;
                            }
                        }
                    }
                `,
                null,
            ])}
    `,
};
